import type { Panel } from '../store/seedanceTypes';

/** Seedance 各子页面的 hash 路径统一在这里维护。 */
export const SEEDANCE_PANEL_ROUTES: Record<Panel, string> = {
  canvas: '/workspace',
  imageGen: '/image-gen',
  library: '/library',
  tasks: '/tasks',
  agreement: '/agreement',
};

/** 顶栏标题（与 Sidebar 文案对应）。 */
export const SEEDANCE_PANEL_TITLES: Record<Panel, string> = {
  canvas: '🎨 创作工作台',
  imageGen: '🖼️ 生成图像',
  library: '📦 素材库',
  tasks: '⏳ 任务管理',
  agreement: '📄 用户协议',
};

export const normalizeRoutePath = (pathname: string) => {
  const normalized = pathname.replace(/\/+$/, '');
  return normalized || '/';
};

export const isTaskListRoute = (pathname: string) => {
  const normalized = normalizeRoutePath(pathname);
  return normalized === '/tasks' || normalized === '/seedance/tasks';
};

/** 任务详情子页路径参数（33dd task_id） */
export const getTaskDetailIdFromRoute = (pathname: string): string | null => {
  const normalized = normalizeRoutePath(pathname);
  const m = normalized.match(/^\/(?:seedance\/)?tasks\/([^/]+)$/);
  if (!m) return null;
  try {
    return decodeURIComponent(m[1]).trim() || null;
  } catch {
    return m[1].trim() || null;
  }
};

export const buildTaskDetailPath = (taskId: string) =>
  `/tasks/${encodeURIComponent(taskId.trim())}`;

export const getSeedancePanelFromRoute = (pathname: string): Panel => {
  const normalized = normalizeRoutePath(pathname);
  if (normalized === '/library' || normalized === '/seedance/library') return 'library';
  if (
    normalized === '/tasks' ||
    normalized === '/seedance/tasks' ||
    getTaskDetailIdFromRoute(pathname)
  ) {
    return 'tasks';
  }
  if (normalized === '/image-gen' || normalized === '/seedance/image-gen') return 'imageGen';
  if (normalized === '/agreement' || normalized === '/seedance/agreement') return 'agreement';
  return 'canvas';
};

export const isKnownSeedancePanelRoute = (pathname: string) => {
  const normalized = normalizeRoutePath(pathname);
  if (getTaskDetailIdFromRoute(pathname)) return true;
  return [
    '/',
    '/workspace',
    '/image-gen',
    '/library',
    '/tasks',
    '/agreement',
    '/seedance/workspace',
    '/seedance/image-gen',
    '/seedance/library',
    '/seedance/tasks',
    '/seedance/agreement',
  ].includes(normalized);
};
